import * as React from 'react';
import { IEvent } from './EventsWidget';

export default function AlarmEventItem(
  event: IEvent,
  index: number,
  isInTooltip: boolean
): JSX.Element {
  return (
    <li
      style={{ marginTop: '4px', width: '100%' }}
      key={`${event.type}-${index}`}
      title={event.title}
    >
      <div>
        <i style={{ color: '#B50536', marginRight: '7px' }} className="cmd-icon cmd-icon-alarm" />
        <span
          // className={`${!isInTooltip ? 'text-truncate' : ''}`}
          className="text-truncate"
          style={{
            width: '250px',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            lineHeight: 'normal',
          }}
        >
          {event.title}
        </span>
      </div>
    </li>
  );
}
